import styled from '@emotion/styled';
import { TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ChromePicker } from 'react-color';
import { TextBox, Typography } from '../../../../../../../components-dummy';
import { LinkButton } from '../../../../../../../components-dummy/LinkButton';

export const SectionStyled = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #e5f1ff59;
  border: 1px solid ${({ theme }) => theme.palette.custom['gray-80']};
`;

export const TextBoxStyled = styled(TextBox)`
  label.MuiFormLabel-root {
    margin-bottom: 0;
    font-size: 18px;
  }
  .input-base-wrapper {
    background-color: ${({ theme }) => theme.palette.common.white};
    border-radius: 4px;
  }
`;

export const FontStyleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
`;

export const FontStyle = styled.div<{ width: number }>`
  width: ${({ width }) => `${width}%`};
  min-width: 95px;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const TextFieldStyled = styled(TextField)`
  min-width: 95px;
  .MuiInputBase-input,
  span {
    color: ${({ theme }) => theme.palette.custom['gray-20']};
  }
  .MuiInputBase-root {
    height: 40px;
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const ToggleButtonGroupStyled = styled(ToggleButtonGroup)`
  &.text-alignment {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;

export const ToggleButtonStyled = styled(ToggleButton)`
  width: 40px;
  height: 40px;
`;

export const ColorBoxStyled = styled.div`
  .MuiInputBase-input {
    color: ${({ theme }) => theme.palette.custom['gray-20']};
  }
`;

export const ChromePickerStyled = styled(ChromePicker)<{ isLayout: boolean }>`
  position: absolute;
  z-index: 9999;
  left: 0;
  top: ${({ isLayout }) => (isLayout ? '40px' : 'auto')};
  bottom: ${({ isLayout }) => (isLayout ? 'auto' : '40px')};
`;

export const ErrorLabelStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom.red};
`;

export const ToggleActiveStyled = styled(LinkButton)<{ isActive: boolean }>`
  margin-left: auto;
  color: ${({ theme, isActive }) => isActive && theme.palette.custom['red-80']};

  svg {
    width: 14px;
    & > path {
      stroke: ${({ theme, isActive }) => isActive && theme.palette.custom['red-80']};
    }
  }
`;
